import React from 'react';
import { Link } from 'react-router-dom';
import './AdminRoute.css';

const AdminRoute = () => {
  return (
    <div className="admin-route">
      <Link to="/" className="back-to-site">
        <i className="fas fa-arrow-left"></i> Back to Website
      </Link>
    </div>
  );
};

export default AdminRoute; 